import { ContentBox } from "@msuite/ui/app-shell";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import React from "react";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { AbsencesMenu } from "./absences-menu";
import { columns } from "./table-config";

export function Absences() {
	/** Hooks */
	const auth = useAuth();

	const {
		data: absences,
		isLoading,
		queryKey,
		refetch,
	} = useQuery({
		queryKey: ["dashboard", "absences"],
		queryFn: async () => {
			if (!auth.user?.id) throw new Error();
			const response = await client.users[":userId"].absences.$get({
				param: { userId: auth.user?.id },
			});
			const data = await responseHandler(response);
			return data.absences;
		},
	});

	/** Render */
	return (
		<React.Fragment>
			<ContentBox>
				<DataTable
					data={guardArray(absences)}
					columns={columns}
					isLoading={isLoading}
					queryKey={queryKey}
					refetch={refetch}
					persistenceKey="absences-table"
					menu={<AbsencesMenu />}
				/>
			</ContentBox>
		</React.Fragment>
	);
}
